import React from 'react';

export const Card: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className = '', ...props }) => (
  <div className={`bg-white rounded-xl border border-gray-100 shadow-md overflow-hidden ${className}`} {...props}>
    {children}
  </div>
);